export const TRANSLATIONS_EN = { 

    /* 1. Track & Trace */

    // Header - Tab
    carrier_web_portal: "Carrier Web Portal",
    track_n_trace: "Track & Trace",
    carrier_performance: "Carrier Performance",

    // Header - Profile Menu
    appendix: "Appendix",
    logout: "Logout",

    // Track & Trace Header
    enter_load_number: "Enter Load #",

    // Table - Header
    load_id: "Load ID",
    carrier_id: "Carrier ID",
    carrier_code: "Carrier Code",
    carrier_desc: "Carrier Desc",
    service: "Service ID",
    service_desc: "Service Desc",
    equip_type: "Equip Type",
    trailer_number: "Trailer Number",
    tm_load_status: "TM Load Status",
    kc_load_status: "KC Load Status",
    pickup_appt_date_time: "Pickup Appt Date/Time",
    pickup_on_time: "Pickup On Time",
    delivery_appt_date_time: "Delivery Appt Date/Time",
    delivery_on_time: "Delivery On Time",
    origin_location_name: "Origin Location Name",
    origin_address: "Origin Address",
    origin_city: "Origin City",
    origin_state: "Origin State",
    origin_country: "Origin Country",
    destination_location_name: "Dest Location Name",
    destination_address: "Dest Address",
    destination_city: "Dest City",
    destination_state: "Dest State",
    destination_country: "Dest Country",
    distance_in_miles: "Distance (Miles)",
    time_left: "Time Remaining to Report",
    pending_task: "Pending Event",
    sent_to_SAP: "Sent To SAP",
    tms_in_sync: "TMS In Sync",
    live_load: "Live Load",  
    appt_required: "Appointment Required",
    appt_confirmed: "Appointment Confirmed",
    vendor_ref: "Vendor REF",
    appt_ref: "Appt Reference",

    //Table - Body
    no_data_to_display: "No Results Found",
    loading_records: "Loading...",

    // Table - subRowComponent
    edit: "Edit",
    cancel: "Cancel",
    submit_changes: "Submit Changes",
    retrigger: "Retrigger",
    arrive_at_pick_stop: "Arrive at Pick Stop",
    depart_from_pick_stop: "Depart from Pick Stop",
    arrive_at_drop_stop: "Arrive at Drop Stop",
    depart_from_drop_stop: "Depart from Drop Stop",
    location: "Location",
    pickup_location: "Pickup Location",
    pickup_appt_data_time: "Pickup Appt Date/Time",
    planned_pickup_appt_date_time: "Planned Pickup Appt Date/Time",
    pickup_appt_reason_code: "Planned Pickup Appt Reason Code",
    carrier_actual_pickup_data_time: "Carrier Actual Pickup Date/Time",
    carrier_actual_depart_data_time: "Carrier Actual Depart Date/Time",
    carrier_actual_pickup_reason_code: "Carrier Actual Pickup Reason Code",
    final_pickup_reason_code: "Final Pickup Reason Code",
    kc_actual_date_time: "FourKites Actual Pickup Date/Time",
    kc_actual_depart_date_time: "FourKites Actual Depart Date/Time",
    kc_delivery_actual_date_time: "FourKites Actual Delivery Date/Time",
    appt_date_time: "Appt. Date/Time",
    reason_code: "Reason Code",
    latest: "Latest",
    old: "Old",
    data_missing: "Data missing",
    drop_location: "Destination Location",
    planned_delivery_appt_date_time: "Planned Delivery Appt Date/Time",
    planned_appt_reason_code: "Planned Delivery Appt Reason Code",
    carrier_actual_delivery_data_time: "Carrier Actual Delivery Date/Time",
    carrier_actual_delivery_reason_code: "Carrier Actual Delivery Reason Code",
    final_delivery_reason_code: "Final Delivery Reason Code",
    carrier_actual_delivery_depart_reason_code: "Carrier Actual Depart Reason Code",
    carrier_actual_pickup_depart_reason_code: "Carrier Actual Depart Reason Code",
    carrier_pickup_on_time: "Carrier Pickup on Time",
    carrier_delivery_on_time: "Carrier Delivery on Time",
    po_pieces_lbs: "PO#, Total Pieces, Total LBS",
    cust_appt_details: "Name, Phone, Email",
    event_reporting_date_time: "Event Reporting Date/Time",

    // Pagination
    displaying: "Displaying",

    // Pending Task
    pending_tasks: "Pending Tasks",

    // Filters
    // status: "Status",
    // origin_name: "Origin Name",
    destination_name: "Destination Name",
    shipment_missing: "Missing Event",
    enter: "Enter",
    transportation_carrier_committed: "Transportation Carrier Committed",
    shipment_created: "Shipment Created",
    checked_in_by_DC: "Checked in by DC",
    loading_started: "Loading Started",
    ready_for_pickup: "Ready for Pickup",
    in_transit: "In Transit",
    delivery_confirmed: "Delivery Confirmed",
    shipment_missing_pick_stop_arrive: "Arrive at Pick Stop",
    shipment_missing_pick_stop_depart: "Depart from Pick Stop",
    shipment_missing_drop_arrive: "Arrive at Drop Stop",
    shipment_missing_drop_depart: "Depart from Drop Stop",
    // show_only_critical_pending_tasks: "Urgent Priority (Red Criteria)",
    // show_only_high_alert_pending_tasks: "High Priority (Yellow Criteria)",
    show_only_critical_pending_tasks: "Missing Carrier Data - FourKites Data Received",
    show_only_high_alert_pending_tasks: "Urgent - No Event Data",
    yes: "Yes",
    no: "No",
    pickup_appt_date: "Pickup Appt Date",
    delivery_appt_date: "Delivery Appt Date",
    tender_accepted_tnt: "Tender Accepted",
    confirming: "Confirming",
    completed: "Completed",
    blank: "Blank",
    clear_all: "Clear All",
    clear: "Clear",
    today: "Today",
    sent_to_SAP_success: "Success",
    sent_to_SAP_pending: "Pending",
    sent_to_SAP_failed: "Failed",

    // Date Wrapper
    start_date: "Start Date",
    end_date: "End Date",
    to: "to",

    // Enum
    arrive_at_pickup: "Arrive at Pickstop",
    depart_from_pickup: "Depart from Pickstop",
    arrive_at_drop: "Arrive at Dropstop",
    depart_from_drop: "Depart from Dropstop",

    // CSV
    load_details: "Load_Details",
    download_started: "Exporting Load Details in progress. This might take a couple of seconds",
    download_completed: "Export successful",
    no_rec_to_download: "No records to download.",
    export_in_progress: "Export in progress",
    stopNum: "Stop #",
    actual_pickup_appt_date_time: "Actual Pickup Appt Date/Time",
    baseline_pickup_appt_date_time: "Baseline Pickup Appt Date/Time",
    actual_delivery_appt_date_time: "Actual Delivery Appt Date/Time",
    baseline_delivery_appt_date_time: "Baseline Delivery Appt Date/Time",
    drop_location_id: "Drop Location ID",
    pickup_location_id: "Pickup Location ID",
    comment: "Comments",

    // edit load
    save: "Save",
    validate: "Validate",
    delete: "Delete Time",
    
    // Text Field
    info_text: "Enter single, multiple or use * to search",

    // Custom Calendar
    select_date_time: "Select Date/Time",

    // Custom Dropdown
    select_option: "Select Option",

    // ApptHistory
    changed_by: "Changed By",
    changed_at: "Changed At",
    note_appt_history_delivery: "*Date used to calculate on time delivery",
    note_appt_history_pickup: "*Date used to calculate on time pickup",

    // PopperDataTable
    poNum: "PO Number",
    totalPiece: "Total Pieces",
    totalLbs: "Total Lbs",

    // Error Message
    please_update: "Please update",
    errorText : "Something Went Wrong, Please Try Again!",

    // Dialog
    pickup: "Pick stop",
    delivery: "Drop stop",
    success: "updated successfully",
    failed_title: "Failed to Update",
    failed: "failed to update",
    partial: "Updated Except",
    due_to: "due to",
    close: "Close",

    // Snackbar messages
    retrigger_successful: "Re-triggered Successfully",
    info_already_sent: "All required info already sent to target systems",

    // Comment
    load: "Load",
    new_message: "New Message",
    no_comments_yet: "No Comments Yet",
    enter_comment: "Enter Comment (max limit 500 characters)",
    text_limit: "Characters left",
    search_comments_failure: "Failed to load comments. Please try again later.",
    add_comment_failure: "Failed to add comment. Please try again later",
    id: "id",

    // Last Update
    last_updated_from_TMS: "Last Updated from TMS on",
    at: "at",

    /* 2. Carrier Performance */

    on_time_delivery: "On Time Delivery",
    on_time_pickup: "Live Load On Time Pickup",
    billing_accuracy: "Billing Accuracy",
    carrier_event_response_efficiency: "Carrier Event Response Efficiency",
    fourKites_tracking_consistency: "FourKites Tracking Consistency",
    first_tender_compliance: "First Tender Compliance",
    lane_award_compliance: "Lane Award Compliance",
    moved_on_spot_rate: "Moved On Spot Rate",
    lane: "Lane",
    awarded: "Awarded",
    tendered: "Tendered",
    tenders_accepted_with_contract_price: "Tenders Accepted With Contract Price",
    compliance: "Compliance",
    tenders_accepted_over_compliance: "Tenders Accepted Over Compliance",
    tenders_accepted_in_freight_auction: "Tenders Accepted In Freight Auction",
    total_compliance: "Total Compliance",
    target: "Target",
    export: "Export",
    all_lanes: "All Lanes",
    awarded_lanes: "Awarded Lanes",
    non_awarded_lanes: "Non-Awarded Lanes",
    total_loads_accepted: "Total Loads Accepted",
    in_contract: "In Contract",
    in_spot_market: "In Spot Market",
    total_loads: "Total Loads",
    delivered_stops: "Delivered Stops",
    on_time: "On Time",
    on_time_delivered_stops: "On Time Delivered Stops",
    late_stops: "Late Stops",
    sto: "STO",
    stops: "Stops",
    cust: "Customer",
    vendor_inbound: "Vendor Inbound",
    picked_stop: "Picked Stops",
    on_time_picked_stops: "On time Picked Stops",
    late_picked_stops: "Late Picked Stops",
    planned_delivery_appointment_date: "Planned Delivery Appointment Date",
    origin_location: "Origin Location",
    search: "Search",
    select_carrier: "Select Carrier",
    search_carrier : "Search Carrier",
    continue: "Continue",
    multi_select: "Multiple Selected",
    date: "Date",
    response_expectation: "Response Expectation",
    hours: "hours",
    response_received: "Response Received",
    ontime_response_received: "On-Time Response Received",
    missing_response: "Missing Response",
    delayed_missing_response: "Delayed/Missing Response",

    // First Tender Complaiance Card
    tender_accepted: "Accepted",
    tender_rejected: "Rejected",
    tender_no_response: "No response",
    acceptance_target: "Acceptance Target",
    // tenders: "Tenders",
    // accepted: "Accepted",
    // no_response: "No Response",
    // rejected: "Rejected",

    // Lane Award Compliance 
    show_only_non_compliant: "Show only Non Compliant",

    // Carrier Event Response Efficency Card
    total_response_rate: "Total Response Rate",
    on_time_response_rate: "On Time Response Rate",
    arrival_at_pickstop: "Arrival at Pickstop",
    departure_from_pickstop:"Departure from Pickstop",
    arrival_at_dropstop: "Arrival at Dropstop",
    departure_from_dropstop: "Departure from Dropstop",
    number_of_pickstops: "Number of Pickstops",
    number_of_dropstops: "Number of Dropstops",

    // FourKites Tracking Consistency Card
    tracked: "Tracked",
    tracking_quality: "Tracking Quality",

    no_data: "No Data Found",
    loading: "Loading...",
    no_access: "You do not have access to view this carrier's performance data",
    
    cp_shipment_type: "Order Type",
    kpi_note_delivery_date: "Based upon selected delivery date",
    kpi_note_pickup_date: "Based upon selected pickup date",
    kpi_note_fourkites_completion_date: "Based Upon selected Fourkites Completion Date",
    kpi_invoice_paid_date: "Based Upon selected Invoice paid date",
    kpi_note_billing: "Origin and Service ID filters will be inactive for this KPI. For further information, contact your KC Freight settlement contact",

    tender_response: "Tender Response",
    week: "Week",
    trailer_pool_compliance: "Trailer Pool Compliance",

    // Billing Accuracy
    total_invoices: "Total Invoices",
    invoices: "Invoices",
    auto_approved: "Auto Approved",

    // Trailer Pool Compliance
    site_number: "Site Number",
    target_pool: "Target Pool",
    actual: "Actual",
    target_delta: "Target Delta",
    daily_compliance_percentage: "Daily Compliance %",
    out_service_trailers: "Out Service Trailers",
    kpi_note_trailer_pool: "Based upon selected DY+ record date",
    error_date_older_than_one_year: "Date cannot be older than 1 year",

    // TMT
    tmt_title: "Dynamic Rate Maintenance Tool",
    tmt: "TMT",
    close_menu: "Close Menu",
    drm_tool: "DRM Tool",
    daily_maintenance: "Daily Maintenance",
    bid_maintenance: "Bid Maintenance",
    drmt_remport: "DRMT Reports",
    filter_text: "Filter here to find details",
    drm_table_filter_error: "Please select at least one",
    drm_table_filter_error_origincountry: "Please select at least one Origin Country",
    drm_table_filter_error_destinationcountry: "Please select at least one Destination Country",
    drm_table_filter_error_division: "Please select at least one division",
    no_rec_to_duplicate: "No Record for the Duplicate",
    save_apply: "Save & Apply",
    manage_table_view: 'Manage your table Views',
    custom_view: "Customize Views",
    enter_view_name: "Enter view name",

    //DRMT Table Headers
    carrierScac: "Carrier",
    serviceScac: "Service",
    tariffNumber: "Tariff No",
    tariffId: "Tariff ID",
    orgHub: "Org Hub",
    originZone: "Org Zone",
    originZoneDesc: "Org Zone Desc",
    originZoneShortDesc: "Org Zone Short Desc",
    originCity: "Org City",
    originState: "Org State",
    originCountry: "Org Cntry",
    destHub: "Dest Hub",
    destinationZone: "Dest Zone",
    destinationZoneDesc: "Dest Zone Desc",
    destinationZoneShortDesc: "Dest Zone Short Desc",
    destinationCity: "Dest City",
    destinationState: "Dest State",
    destinationCountry: "Dest Cntry",
    region: "Region",
    carrierManager: "Carrier Manager",
    miles: "Miles",
    orderType: "Order Type",
    laneServiceType: "Order Type",
    primaryCustomers: "Primary Customer",
    preAwarded: "Pre-Awarded",
    equipmentType: "Equip Type",
    laneDescription: "Lane Description",
    lineHaulChargeType: "Charge ID",
    btfRate: "BTF Rate",
    lineHaulRate: "Base Rate",
    rate: "Base Rate",
    awardBackup: "Award/Backup",
    effectiveDate: "Effective Date",
    expirationDate: "Expiration Date",
    bucketType: "Bucket Type",
    qtyBucketType: "Qty Bucket Type",
    pctBucketType: "Pct Bucket Type",
    qtyActiveFlag: "Qty Active Flag",
    qtyStartDate: "Qty Start Date",
    qtyEndDate: "Qty End Date",
    minShipmentsAllocated: "Min Qty Award",
    maxShipmentsAllocated: "Max Qty Award",
    percentageActiveFlag: "Pct Active Flag",
    pctStartDate: "Pct Start Date",
    pctEndDate: "Pct End Date",
    minCarrierAllocationPercentage: "Pct Award",
    maxCarrierAllocationPercentage: "Pct Award",
    modeOfTransport: "Mode",
    status: "Status",
    bidFileName: "Bid File Name",
    changeComment: "Change Comments",
    coupaFileRecordErrors: "Errors",
    errors: "Errors",
    defaultError: "Error",
    message: 'TM Response',
    userId: 'User Name',
    systemRateId: 'Rate ID',
    createdDate: 'Transaction Date',
    select_division_error: "Please select at least one division",
    select_country_error: "Please select at least one country",
    select_destination_error: "Please select at least one destination",


    error_selected_row: "Errors in Selected Row",
    no_error_found: "No errors found.",

    // Daily Maintenance Validation Errors
    daily_validation_original_record_not_found: "No changes found for the sagaId: {sagaId}",
    daily_validation_effective_date_past: "Effective date ({date}) cannot be earlier than today's date for sagaId: {sagaId}",
    daily_validation_expiration_date_past: "Expiration date ({date}) cannot be earlier than today's date for sagaId: {sagaId}",
    daily_validation_effective_after_expiration: "Effective date must be earlier than expiration date for sagaId: {sagaId}",
    daily_validation_effective_after_old_expiration: "New effective date ({newDate}) cannot be later than the existing expiration date ({oldDate}) for sagaId: {sagaId}",
    daily_validation_expiration_before_old_effective: "New expiration date ({newDate}) cannot be earlier than the existing effective date ({oldDate}) for sagaId: {sagaId}",
    daily_validation_rate_requires_effective_date: "Effective date must be changed when rate is modified for sagaId: {sagaId}",
    line_haul_rate_must_be_greater_than_zero: "Base Rate must be greater than zero",
    must_be_greater_than_zero: "Numeric Column Value must be greater than zero",
    daily_validation_effective_date_earlier_restriction: "New effective date cannot be earlier than previous effective date ({oldDate}) for sagaId: {sagaId}. This restriction is only relaxed when both dates are in the future.",
    daily_validation_processing_error: "Error processing data: {error}",
    daily_validation_invalid_change_combination : "Invalid change set. Adjust effective, expiration, rate, dependent fields, or provide a change comment before submitting {sagaId}",
    daily_tariffid_award_mismatch: "Award/Backup value incorrect as per Tariff ID",
    tariff_number_must_match_carrier: "Tariff number and carrier must be consistent.",
    submit_status_validation: "Selected rows are not ready to process.",
    audit_history: "Audit History",
    audit_history_content: "Daily Maintenance Change Log Audit History",
    selected_file_name: "Selected file name: ",
    process: "Process",
    coupa_file_upload_error: "Please select a valid file type (CSV, Excel)",
    delete_dialog_title: "Delete the selected Bid Table Data",
    delete_dialog_content: "Are you sure you want to delete the selected table data?",
    delete_btn: "Delete",
    expire_btn: "Expire",
    flip_flag_btn: "Match Override",
    flip_flag_not_allowed_message: "Allowed only for records with these statuses: Lane creation success, Rate expire success.",
    flip_flag_dialog_title: "Match Override",
    flip_flag_dialog_content: "Are you sure you want to apply the match override for the selected records?",
    delete_coupa_dialog_title: "Delete records by filename",
    delete_coupa_selected_content: "Are you sure you want to process the selected records?",
    delete_coupa_all_content: "No rows are selected. This will delete all record file currently listed. Do you want to proceed?",
    update_coupa_dialog_title: "Submit records by filename",
    update_coupa_selected_content: "Are you sure you want submit the selected records?",
    expire_coupa_dialog_title: "Expire records by filename",
    expire_dialog_title: "Expire the selected Bid Table Data",
    expire_coupa_selected_content: "Are you sure you want to expire the selected records?",
    expire_dialog_content: "Are you sure you want to expire the selected table data?",
    update_coupa_all_content: "No rows are selected. This will resubmit all records file currently listed. Do you want to proceed?",
    download_cea_dialog_title: "Download CEA Profile Files",
    download_cea_selected_content: "Are you sure you want to download the selected CEA profile files?",
    save_dialog_title: "Save the Updated Bid Table Data",
    save_dialog_content: "You updated ",
    submit_dialog_title: "Submit to process the data",
    submit_dialog_content : "Are you sure you want to submit to proceed?",
    cancel_dialog_title: "Cancel the Daily Maintenance changes",
    cancel_dialog_content: "Are you sure you want to cancel the changes made?",
    submit: "Submit",
    import: "Import",
    import_dialog_title: "Selected File Name is ",
    import_dialog_content: "Are you sure you want to proceed with this file?",
    remove: "Remove",
    proceed: "Proceed",
    text_place_holder: "Enter values separated by commas",
    text_title: "Separate multiple values with semicolon",
    number_title: "Separate multiple values with semicolon(numbers only)  (Supports operators: >, <, >=, <=, =, !=)",
    number_title_edit: "Enter Number only",
    auto_complete_place_holder: 'Type to search',
    comparison_operator: "Comparison Operator",
 
    all : 'All',
    small: 'Small',
    medium: "Medium",
    add_item: "Add Item",
    duplicate_item: "Duplicate Item",
    change_log_history: "Change Log History",
    download: "Download",
    select_rows_to_download: "Please select rows to download.",
    refresh: "Refresh",
    hide_column: "Hide Column",
    table_density: 'Density',
    live_load_error_next_page: "Error loading next page:",
    live_load_error_search: "Error searching options:",
    live_load_error_select: "Error on option select:",
    live_load_load_more: "Loading more options...",
    live_load_no_search_data: "No search results found for ",
    live_load_placeholder: "Type to search (separate with ';' for multiple terms)",
    large: "Large",

    //DRMT REPORT
    drmt_report: "Reports",
    drmt_report_download: "Download the",
    drmt_report_download_confirmation: "Do you want to download this report?",

    drmt_bid_update_validation: "Validate your updated columns before you submit",

    duplicate_record: "Duplicated record",
    cancel_not_allowed_message: "Cancel is allowed only for records with these statuses: Pre-validation failed, Rate creation failed, Lane creation failed, Rate expiry failed, Rate update failed.",
    daily_required_fields_missing: "Please complete all required fields before submitting. Missing required field:",
    daily_submit_restricted_by_status: "Submit is not allowed for records in processing or completed statuses.",
    daily_submit_restriction_of_some_field_changes: "Submit is not allowed for TMS record when there are changes to only for change Comments, please Refresh",
    daily_new_or_duplicated_record_date_validation: "Effective date and expiration date must be today or in the future for new or duplicated records. or Effective date need to be before the Expiration date",
    drmt_report_missing_selection: "Unable to download. Please try again.",
    drmt_report_not_configured: "This report is not yet available for download.",
    drmt_report_no_data: "No records available for download.",
    drmt_report_download_success: "Report download completed",

    gateway_timeout_error: "API Transaction to DRMT tables timed out. Please try again.",

    placeholder_number_filter: "e.g., >1000; <=5000 or 1,000;2,500",
    placeholder_number_editable: "e.g., 1000",

    fileName: "Coupa File Names",
    fileCategory: "Category",
    createdAt: "Processed Date",
    countOfProcessableRecords: "No. of Records to Submit",
    countOfDeletableRecords: "No. of Records to Delete",
    countOfRateExpirationRecords: "Records to expire",
    coupa_file_delete_details: "Records File Delete Details",
    delete_coupa_file: "Filename Processing",
    selected_row: "Rows Selected |",    

    cea_profile_download: "CEA Profile Download",
    uploadedDate: "Uploaded Date",
    dataStoredUnit: "Data Stored Unit",
    fileSize: "File Size (kB)",
    from_date: "From Date",
    to_date: "To Date",
    isDownloaded: "Download Flag",
    fileNames: "File Name"

}